import {useContext} from 'react'

import Context from '@s-ui/react-context'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

export const PanelFinancingHeader = () => {
  const {i18n} = useContext(Context)

  return (
    <div className="mt-PanelFinancing-header">
      <TitleBasic
        as={titleBasicTags.h2}
        color={titleBasicColors.black}
        size={titleBasicSizes.xs}
        title={i18n.t('PANEL_FINANCING.SIMPLIFIED.TITLE')}
      />
    </div>
  )
}
